import { FolderOpen, Info } from 'lucide-react';
import { SECTIONS, sectionById } from './projectSections';

/**
 * ProjectHorizontalNav — V17.0 : 4 sections (Dashboard · Production · Ressources · Paramètres)
 * + rangée de sous-onglets, charte Atelier claire.
 */
const ProjectHorizontalNav = ({ activeSection, activeTab, onChange, projectName, projectDescription }) => {
  const current = sectionById(activeSection);
  return (
    <div className="w-full border-b border-[var(--c-border)] bg-[var(--c-surface-0)]" data-testid="project-horizontal-nav">
      <div className="flex items-end gap-1 px-4 sm:px-6 lg:px-8 pt-2 flex-wrap">
        <div className="flex items-center gap-2 pr-4 mr-2 pb-2.5 border-r border-[var(--c-border)] min-w-0">
          <FolderOpen className="w-3.5 h-3.5 text-[var(--c-gold)] shrink-0" />
          <span className="text-[12.5px] font-semibold text-[var(--c-text)] truncate max-w-[220px]" style={{ fontFamily: 'Outfit, sans-serif' }} data-testid="project-nav-name">{projectName || 'Projet'}</span>
          {projectDescription && <Info className="w-3 h-3 text-[var(--c-text-faint)] shrink-0" title={projectDescription} />}
        </div>
        {SECTIONS.map((s) => {
          const active = s.id === activeSection;
          return (
            <button key={s.id} type="button" onClick={() => onChange(s.id, s.tabs[0]?.id || null)}
              className={`relative inline-flex items-center gap-2 h-10 px-3 rounded-t-lg text-[12.5px] transition-colors ${active ? 'text-[var(--c-text)] font-semibold' : 'text-[var(--c-text-muted)] hover:text-[var(--c-text)] hover:bg-[var(--c-surface-2)]'}`}
              title={s.sub} data-testid={`project-nav-${s.id}`} aria-current={active ? 'page' : undefined}>
              <s.icon className={`w-3.5 h-3.5 ${active ? 'text-[var(--c-gold)]' : ''}`} strokeWidth={1.75} />
              {s.label}
              {active && <span className="absolute left-2 right-2 -bottom-px h-[2px] rounded-full bg-[var(--c-gold)]" />}
            </button>
          );
        })}
      </div>
      {current?.tabs?.length > 0 && (
        <div className="flex items-center gap-1 px-4 sm:px-6 lg:px-8 py-1.5 border-t border-[var(--c-border)] bg-[var(--c-surface-1)]" data-testid="project-subnav">
          {current.tabs.map((t) => {
            const active = t.id === activeTab;
            return (
              <button key={t.id} type="button" onClick={() => onChange(current.id, t.id)} title={t.hint}
                className={`inline-flex items-center gap-1.5 h-7 px-2.5 rounded-full text-[11.5px] border transition-colors ${active ? 'bg-[var(--c-text)] text-[var(--c-surface-0)] border-transparent' : 'border-[var(--c-border)] text-[var(--c-text-muted)] hover:border-[var(--c-border-strong)] hover:text-[var(--c-text)]'}`}
                data-testid={`project-tab-${t.id}`}>
                {t.icon && <t.icon className="w-3 h-3" strokeWidth={1.75} />}{t.label}
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default ProjectHorizontalNav;
